/* istanbul ignore file */
import { useState, useEffect } from 'react';
import usePositionService from '../position/positionService';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';

const EmployeePositionField = (props: FieldProps) => {
  const { findPositionById } = usePositionService();
  const { getValue } = useFieldHelper(props);
  const [displayedValue, setDisplayedValue] = useState<Nullable<string>>(null);

  useEffect(() => {
    (async () => {
      const position = await findPositionById(getValue());
      setDisplayedValue(position.name);
    })();
  });

  return <TextField {...props} value={displayedValue} />;
};

export default EmployeePositionField;
